import { useContext } from 'react';

import { SupplierSubscriptionPlansContext } from './SupplierSubscriptionPlansContext';

export const useSupplierSubscriptionPlans = () => {
    const context = useContext(SupplierSubscriptionPlansContext);
    if (!context) {
        throw new Error('useSupplierSubscriptionPlans must be used within SupplierSubscriptionPlansProvider');
    }
    return context;
};
